import { Component, HostListener, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

declare var bootstrap: any;

@Component({
  selector: 'app-modal-intencao-saida',
  standalone: true,

  templateUrl: './modal-intencao-saida.component.html',
  styleUrls: ['./modal-intencao-saida.component.scss'],
})
export class ModalIntencaoSaidaComponent implements OnInit {
  private modalShown = false;

  constructor(public bsModalRef: BsModalRef) {}

  ngOnInit() {}

  @HostListener('document:mouseout', ['$event'])
  onMouseOut(event: MouseEvent) {
    if (!this.modalShown && event.clientY < 10) {
      this.modalShown = true;
      const modalElement = document.getElementById('modalIntencaoSaida');
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
    }
  }

  onClose(): void {
    this.bsModalRef.hide();
  }
}
